import Loadable from 'react-loadable';

export const LoadableHealthcheck = Loadable({
  loader: () => import('../components/Healthcheck/Healthcheck.react'),
  loading: () => null,
});

export const LoadableLogin = Loadable({
  loader: () => import('../components/Login'),
  loading: () => null,
});

export const LoadableLoginCallback = Loadable({
  loader: () => import('../components/LoginCallback'),
  loading: () => null,
});

export const LoadableLogout = Loadable({
  loader: () => import('../components/Logout'),
  loading: () => null,
});

export const LoadableRaceAlerts = Loadable({
  loader: () => import('../components/RaceAlerts/components/Alerts'),
  loading: () => null,
});

export const LoadableRaceAlertsAdd = Loadable({
  loader: () => import('../components/RaceAlerts/components/Add'),
  loading: () => null,
});

export const LoadableStripeConnectLanding = Loadable({
  loader: () => import('../components/Stripe/Connect/Landing'),
  loading: () => null,
});

export const LoadableStripeConnectSuccess = Loadable({
  loader: () => import('../components/Stripe/Connect/Success'),
  loading: () => null,
});

export const LoadableSavedEventsPage = Loadable({
  loader: () => import('../containers/SavedEventsPage'),
  loading: () => null,
});

export const LoadableLikeActivityPage = Loadable({
  loader: () => import('../components/ProfilePage/components/LikeActivityPage'),
  loading: () => null,
});

export const LoadableUnlikeActivityPage = Loadable({
  loader: () => import('../components/ProfilePage/components/UnlikeActivityPage'),
  loading: () => null,
});

export const LoadableCommentOnActivityPage = Loadable({
  loader: () => import('../components/ProfilePage/components/CommentOnActivityPage'),
  loading: () => null,
});

export const LoadableSaveEventPage = Loadable({
  loader: () => import('../containers/SaveEventPage'),
  loading: () => null,
});

export const LoadableUnsaveEventPage = Loadable({
  loader: () => import('../containers/UnsaveEventPage'),
  loading: () => null,
});

export const LoadableSaveExternalBookingPage = Loadable({
  loader: () => import('../containers/SaveExternalBookingPage'),
  loading: () => null,
});

export const LoadableUnsaveExternalBookingPage = Loadable({
  loader: () => import('../containers/UnsaveExternalBookingPage'),
  loading: () => null,
});

export const LoadableSaveSearchPage = Loadable({
  loader: () => import('../containers/SaveSearchPage'),
  loading: () => null,
});

export const LoadableUnsaveSearchPage = Loadable({
  loader: () => import('../containers/UnsaveSearchPage'),
  loading: () => null,
});

export const LoadableEventSearchPage = Loadable({
  loader: () => import('../containers/EventSearchPage'),
  loading: () => null,
});

export const LoadablePublicProfilePage = Loadable({
  loader: () => import('../components/ProfilePage/public'),
  loading: () => null,
});

export const LoadablePrivateProfilePage = Loadable({
  loader: () => import('../components/ProfilePage/private'),
  loading: () => null,
});

export const LoadableProfileSettingsPage = Loadable({
  loader: () => import('../components/ProfileSettingsPage'),
  loading: () => null,
});

export const LoadableBookingFormPage = Loadable({
  loader: () => import('../containers/BookingFormPage'),
  loading: () => null,
});

export const LoadablePrivacy = Loadable({
  loader: () => import('../components/Legal/components/Privacy'),
  loading: () => null,
});

export const LoadableTerms = Loadable({
  loader: () => import('../components/Legal/components/Terms'),
  loading: () => null,
});

export const LoadableNotFound = Loadable({
  loader: () => import('../components/NotFound'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/src/routes/loadables.jsx